module.exports = "<div>\r\n  <vehicle-List publish-Mode=\"true\"></vehicle-List>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/vehicle/vehiclePublish/vehiclePublish.html
// module id = 1131
// module chunks = 0